// General
export const possiblePixelError = 0.5 // Margin of error for pixel computations
export const defaultManifestFilename = "manifest.json" // Title of the JSON in the DiViNa folder
export const defaultBackgroundColor = 0x000000 // Black to ensure the loading message is visible

// Loading message
export const textFontFamily = "Arial"
export const textFontSize = 24
export const textFillColor = 0xFFFFFF // White to ensure the message is visible
export const wordWrapWidth = 275 // Maximum line width

// Story
export const defaultContinuous = false // If none
export const defaultOverflow = "scrolled" // If none or "auto"
export const defaultFit = "contain" // If none
export const defaultSnapBehavior = "free" // If none
export const defaultDuration = 750 // Used for transitions and snap point jumps

// Interactions
export const referencePercent = 0.3 // % of the screen dimension to detect forward/backward taps
export const velocityFactor = 10 // For a kinetic scroll
export const timeConstant = 325 // For a kinetic scroll

// Snap point speeds: speeds are computed such that the viewport will move by 1 relevant dimension
// (= the viewport's width or height in pixels) in defaultDuration milliseconds
export const snapJumpSpeedFactor = 1 / defaultDuration
// Duration of a snap point jump = distance in px / speed,
// where speed is defaultDuration * snapJumpSpeedFactor (see Page's resize function)
export const stickyMoveSpeedFactor = 1 / defaultDuration
// Duration of a sticky snap point move = distance in px / speed,
// where speed is defaultDuration * stickyMoveSpeedFactor (see Page's resize function)